import actionTypes from './SettingActionType'

const initialState = {
  settingTheme: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_THEME:
      let parsedThemeConfig = action.data?.themeConfig
      if (typeof parsedThemeConfig === 'string') {
        try {
          parsedThemeConfig = JSON.parse(parsedThemeConfig)
        } catch (e) {
          parsedThemeConfig = {}
        }
      }

      return {
        ...state,
        settingTheme: {
          ...action.data,
          themeConfig: parsedThemeConfig,
        }
      }

    default:
      return state
  }
}
